<template lang="pug">
  .container
    div.content-cadastro
      app-listagem(
        :tituloCard="tituloCard"
        :hasActionButton="true"
        :sizeActionButton="sizeActionButton"
        :nameActionButton="nameActionButton"
        :hasHeader="true"
        :hasRefreshButton="false"
        :headerLabel="headerLabel"
        :dataForTable="cadastros"
        :totalElements="totalCadastros"
        :pagina="pagina"
        @click="novoCadastro"
        @changePage="changePage"
      )
        template(slot="columns")
          el-table-column(
            label="Nome do cadastrante"
            :formatter="cadastranteFormatNome"
          )
          el-table-column(
            label="Nome/Razão social do interessado",
            prop="nomeRazaoSocial"
            sortable
          )
          el-table-column(
            label="CPF/CNPJ do interessado",
            :formatter="interessadoFormatCpfCnpj"
          )
          el-table-column(
            label="Data de atualização",
            width="160",
            :formatter="setData",
          )
          el-table-column(
            label="Número do processo",
            prop="numeroProcesso"
          )
          el-table-column(
            label="Tipo do processo",
            prop="nomeTipoProcesso"
          )

          el-table-column(
            label="Ações",
            width="110",
            align="center"
          )
            template(slot-scope='scope')
              el-dropdown(trigger="click", size="small")
                el-button(type='primary', size="mini")
                  | Ações
                  i.el-icon-arrow-down.el-icon--right
                el-dropdown-menu(slot='dropdown')
                  div.oi
                    el-dropdown-item
                      .flex(@click="continuar(scope.row)")
                        i.fal.fa-pencil-alt
                        | &nbsp Continuar Cadastro
                  div.oi
                    el-dropdown-item
                      .flex(@click="remove(scope.row)")
                        i.fa.fa-times
                        | &nbsp Remover Cadastro

</template>

<script>
import { mapActions } from 'vuex'
import AppCabecalho from '@/components/AppCabecalho'
import AppListagemCadastros from '../../../components/cadastro/AppListagemCadastros'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppListagem from '@/components/shared/AppListagem'
import moment from 'moment'
const { tiposProcessosFisicos } = require('@/utils/' +
  process.env.ESTADO +
  '/regrasCentral').default

export default {
  mixins: [
    AppNotificacao
  ],

  components: {
    AppCabecalho,
    AppListagemCadastros,
    AppListagem
  },

  mounted () {
    this.loadLista({ newPage: 0 })
  },

  data () {
    return {
      pagina: 1,
      tituloCard: 'Solicitações de processos físicos existentes',
      headerLabel: 'Listagem de processos físicos',
      sizeActionButton: 'medium',
      nameActionButton: 'Novo cadastro',
      totalCadastros: 0,
      cadastros: []
    }
  },

  methods: {
    ...mapActions({
      getCadastros: 'listagem/getItemsProcessoFisico',
      delete: 'listagem/delete'
    }),

    async loadLista ({ newPage }) {
      let dados = await this.getCadastros({ tiposCadastro: tiposProcessosFisicos, numeroPagina: newPage, limite: 10 })
      this.cadastros = dados.content

      this.cadastros.forEach(cadastro => {
        cadastro.nomeRazaoSocial = this.setNomeRazao(cadastro)
      })

      this.totalCadastros = dados.totalElements
    },

    setNomeRazao (cadastro) {
      if (!cadastro) {
        return '-'
      }
      const pessoa = JSON.parse(cadastro.pessoaInteressado)
      return pessoa.tipo === 'PF' ? pessoa.pessoaFisica.nome || '-' : pessoa.pessoaJuridica.razaoSocial || '-'
    },

    interessadoFormatCpfCnpj (row, column, prop) {
      if (!row) {
        return '-'
      }
      const pessoa = JSON.parse(row.pessoaInteressado)
      return pessoa.tipo === 'PF' ? pessoa.pessoaFisica.cpf || '-' : pessoa.pessoaJuridica.cnpj || '-'
    },

    interessadoFormatNome (row, column, prop) {
      if (!row) {
        return '-'
      }
      const pessoa = JSON.parse(row.pessoaInteressado)
      return pessoa.tipo === 'PF' ? pessoa.pessoaFisica.nome || '-' : pessoa.pessoaJuridica.razaoSocial || '-'
    },

    cadastranteFormatNome (row, column, prop) {
      if (!row) {
        return '-'
      }
      const pessoa = JSON.parse(row.pessoaCadastrante).pessoa
      return pessoa.nomeRazaoSocial || '-'
    },

    setData (row) {
      if (row.data) {
        return moment(row.data).format('DD/MM/YYYY') + ' ' + moment(row.data).format('HH:mm:ss')
      }
      return '-'
    },

    formataRots () {
      return this.$route.path.includes('central') ? '' : this.$route.path.split('/')[1] + '/'
    },

    novoCadastro () {
      this.$router.push({
        name: this.formataRots() + 'cadastro/escolher-tipo-processo-fisico',
        params: {}
      })
    },

    changePage (newPage) {
      this.pagina = newPage
      this.loadLista({ newPage: newPage - 1 })
    },

    updateListagem () {
      this.changePage(1)
    },

    async remove (object) {
      this.confirmBox('Depois de removido, não será possível recuperar este cadastro. Tem certeza que deseja remover este cadastro?',
        this.$messages.TITULO_WARNING,
        async () => {
          await this.delete(object.id)
          this.changePage(1)
        },
        () => {
        }, 'Confimar', 'Cancelar')
    },

    continuar (row) {
      this.$router.push({
        name: this.formataRots() + 'processo-fisico/cadastrante',
        params: {
          idCadastro: row.id
        }
      })
    }
  }
}

</script>

<style lang="scss" scoped>
.content-cadastro {
  padding: 20px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/screens/central/cadastros/maranhao/processoFisico/Home.vue